
import { ServiceAccountManager } from "@/components/settings/ServiceAccountManager";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle, Info } from "lucide-react";
import { useUserRoles } from "@/hooks/useUserRoles";

export const ServiceAccountsTab = () => {
  const { isAdmin } = useUserRoles();

  if (!isAdmin) {
    return (
      <Alert variant="destructive" className="mb-4">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>Access Denied</AlertTitle>
        <AlertDescription>
          You don't have permission to manage service accounts.
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>External Notifications System</CardTitle>
          <CardDescription>
            Connect external notification systems securely to your scheduling data
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Alert>
            <Info className="h-4 w-4" />
            <AlertTitle>Real-time Connection Information</AlertTitle>
            <AlertDescription>
              <p className="mt-2">
                The following tables are enabled for real-time updates and can be used by external notification systems:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li><code className="text-xs bg-muted p-1 rounded">team_schedules</code> - Schedule information</li>  
                <li><code className="text-xs bg-muted p-1 rounded">shift_notifications</code> - Notification tracking</li>
                <li><code className="text-xs bg-muted p-1 rounded">notification_settings</code> - Settings for alerts</li>
                <li><code className="text-xs bg-muted p-1 rounded">profiles</code> - User profile information</li>
              </ul>
              <p className="mt-2">
                Use the service accounts below to authenticate your external notification system.
              </p>
            </AlertDescription>
          </Alert>
        </CardContent>
      </Card>

      <ServiceAccountManager />
    </div>
  );
};

export default ServiceAccountsTab;
